import { ProjectPage } from 'src/projects/ProjectPage.tsx';
import { ReactNode } from 'react';
import { RouteObject } from 'react-router/dist/lib/context';
import { RouterProjectNavigationProvider } from 'src/projects/navigation/RouterProjectNavigationProvider.tsx';

export const createChildrenRoute = (Index: ReactNode): RouteObject[] => [
    {
        index: true,
        element: Index,
    },
    {
        path: 'projects/:page',
        element: (
            <RouterProjectNavigationProvider>
                <ProjectPage/>
            </RouterProjectNavigationProvider>
        ),
    },
];
